// extracted by mini-css-extract-plugin
export default {"caption":"EmptyState_caption__tfR2N","root":"EmptyState_root__VKfeY"};